export default __webpack_public_path__ + "static/improvement-calculator-light-mode-aed1c4917d28126ec2e9f4ae78cb8ebe.mp4";